import type { NotificationBannerProps } from '@enter/business-components/components/notification-banner';

/** Header 的文档流占位与共享 Banner 高度一致。 */
export function getHeaderBannerLayout(banner: NotificationBannerProps | null) {
    const hasCountdown = Boolean(banner?.countdownEndTime || banner?.carouselItems?.some((item) => item.countdownEndTime));
    return { hasCountdown, spacerClassName: hasCountdown ? 'h-9' as const : 'h-8' as const };
}
